/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CART_FRAGMENT } from '@/cart/api/graphql/CartFragment';
import { CART_ITEMS_PAGINATION_ARGUMENTS } from '@/cart/api/graphql/arguments';

export const SET_GIFT_OPTIONS_ON_CART_MUTATION = `
  mutation SET_GIFT_OPTIONS_ON_CART_MUTATION($cartId: String!, $giftMessage: GiftMessageInput, $giftWrappingId: ID, $giftReceiptIncluded: Boolean!, $printedCardIncluded: Boolean!, ${CART_ITEMS_PAGINATION_ARGUMENTS}) {
 setGiftOptionsOnCart(
    input: {
     cart_id: $cartId
     gift_message: $giftMessage
     gift_wrapping_id: $giftWrappingId
     gift_receipt_included: $giftReceiptIncluded
     printed_card_included: $printedCardIncluded
    }
  ) {
    cart {
      ...CART_FRAGMENT
    }
  }
}
${CART_FRAGMENT}
`;
